import 'svg-innerhtml-polyfill'
import 'classlist-polyfill'
import 'core-js/actual/array/reduce'
import 'core-js/actual/array/concat'
import 'core-js/actual/object/keys'
import 'core-js/actual/object/assign'
import 'core-js/actual/array/includes'
import 'core-js/actual/array/at'
import 'core-js/actual/dom-collections/for-each'

import Graphic from './Graphic.svelte'
import { getNode } from './utils'

if (VERSION !== 'production') {
	window.COLLECT_TRANSLATABLES = true
	window.EUROVIZ_OPTIONS = {
		// graphicId: '01_mariupol__slider_1',
		// graphicId: '02_bakhmut__slider_1',
		// graphicId: '03_kherson__slider_1',
		//graphicId: '04_sievierodonetsk__slider_1',
		// graphicId: '01_mariupol__map',
		graphicId: '02_bakhmut__map',
		// graphicId: '03_kherson__map',
		// graphicId: '04_sievierodonetsk__map',
		containerId: 'tsg-graphic',
		options: {
			// highlight: ['Berlin', 'Paris'],
			// city: "Berlin",
		},
		language: 'hu',
		translations: {
			'Where is the most expensive rent in': 'Wo ist die Miete am teuersten in',
			low: 'niedrig',
			high: 'hoch',
			// 'Compared to the whole city': 'im Vergleich zur ganzen Stadt',
			// "Property price classes": "Τράπεζες Τράπεζες",
			Hello: 'Bye'
			// District: "blubb",
		},
		colors: {
			// primary: "#ff0000",
			// background: "pink",
		},
		data: null
	}

	if (window.EUROVIZ_OPTIONS.colors.background)
		document.querySelector('body').style.background = window.EUROVIZ_OPTIONS.colors.background
}

const containerOuter = getNode(`#${window.EUROVIZ_OPTIONS.containerId}`)
let container = containerOuter.querySelector('.tsg-container-embed')

if (!container) {
	container = document.createElement('div')
	container.classList.add('tsg-container-direct')
	containerOuter.appendChild(container)
}

if (container) {
	new Graphic({
		target: container,
		hydrate: true,
		intro: true,
		props: {
			...window.EUROVIZ_OPTIONS
		}
	})
}
